export function EnvironmentBadge() {
  const environment = import.meta.env.VITE_APP_ENV
  if (environment !== 'STAGING' && environment !== 'TEST') return null

  const label = environment === 'STAGING' ? 'Ambiente de homologação' : 'Ambiente de teste'

  return (
    <aside className="environment-badge no-print" role="status" aria-label={label}>
      {label}
    </aside>
  )
}
